/**
 * 로그인 후 user 정보 저장함
 */

import { create } from "zustand";
import { persist } from "zustand/middleware";

interface SetLodGrpState {
  lodGrpList: any[];
  setLodGrpList: (value: any[]) => void;
}

const useLodGrpListStore = create<SetLodGrpState>()(
  persist(
    (set) => ({
      lodGrpList: [],

      setLodGrpList: (value) => {
        set({ lodGrpList: value });
      },
    }),
    {
      name: "lodGrp-storage",
      partialize: (state) => ({
        lodGrp: state.lodGrpList,
      }),
    }
  )
);

export default useLodGrpListStore;
